import { withNamespaces } from "react-i18next";
import { useEffect, useState } from "react";
import { Col, Container, Row, Tooltip } from "reactstrap";
import { useRouteMatch, Route, Switch, useHistory } from "react-router-dom";
import { withRouter } from "react-router-dom";

// components
import PageBody from "../../../../components/page-body";
import PageContent from "../../../../components/page-content";
import Navigator from "src/components/Navigator";
import QuestionaireTypesTabs from "./components/questionaire-types-tabs";
import DataProtectionEditQuestionnaire from "../../administration/questionaire/edit";

import QuestionnaireDesignerService from 'src/modules/data-protection/apis/QuestionnaireDesignerService';

import { toast } from 'react-toastify';

import { useQuery } from "@tanstack/react-query";

const DataProtectionQuestionnairesList = (props) => {
  const [questionaireList, setQuestionaireList] = useState([]);
  const [selectedQuestionaire, setSelectedQuestionaire] = useState(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { t } = props;
  const { path } = useRouteMatch();
  const history = useHistory();

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const handleFetchQuestionaireList = useQuery({
    queryKey: ["data-protection-questionaire-list"],
    queryFn: async () => {
      const service = QuestionnaireDesignerService.getInstance();

      return await service.list();
    },
    cacheTime: 0,
    onError: (error) => {
      if (process.env.NODE_ENV === 'development') console.error(error);

      toast(t("An error occurred while fetching questionnaires list."), {
        type: "error",
      });
    },
  });

  useEffect(() => {
    setQuestionaireList(handleFetchQuestionaireList?.data || []);
  }, [handleFetchQuestionaireList.data]);

  const activeQuestionaireChanged = (id) => {
    if(id){
      id = Number.parseInt(id);
      setSelectedQuestionaire(questionaireList.find((q) => {
        return Number.parseInt(q.id) === id;
      }));
    }
  };
  
  return (
    <PageContent classNames="data-protection-software-details-page">
      <Container fluid>
        <Row>
          <Col lg="12" className="mb-4">
            <Navigator
              pageTitle="Questionnaire Designer"
              breadCrumbs={[
                { title: "SIP", link: "/admin/data-protection/dashboard" },
                { title: "Questionnaire Designer", link: "/admin/data-protection/administration/questionnaire" },
                { title: selectedQuestionaire?.title || "Questionnaire", link: "#" },
              ]}
              backButtonOptions={(d) => ({
                ...d,
                enable: true,
                onClick: () => history.push("/admin/data-protection/dashboard"),
              })}
            >
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                id="tooltipTarget"
                style={{ cursor: "pointer" }}
              />
              <Tooltip
                placement="right"
                isOpen={tooltipOpen}
                target="tooltipTarget"
                toggle={toggleTooltip}
              >
                {t("The questionnaire designer is only editable in English.")}
              </Tooltip>
            </Navigator>
          </Col>
        </Row>

        {/* page body */}
        <PageBody classNames="p-4">
            <QuestionaireTypesTabs t={t} questionaires={ questionaireList } onActiveQuestionaireChanged={ activeQuestionaireChanged } />

            <div className="mt-3">
                <Switch>
                    <Route exact path={path}>
                        <DataProtectionEditQuestionnaire selectedQuestionaire={selectedQuestionaire}/>
                    </Route>
                </Switch>
            </div>
        </PageBody>
      </Container>
    </PageContent>
  );
};

export default withNamespaces()(
  withRouter(DataProtectionQuestionnairesList)
);
